import React from 'react';
import s from './message-skeleton.module.scss';
import classNames from 'classnames';

export const MessageSkeleton = ({ isMine }) => {
  return (
    <div className={classNames(s.message, isMine && s.mine)}>
      <div className={s.bubble}>
        <div className={s.line} />
        <div className={s.shortLine} />
      </div>
    </div>
  );
};

export const MessageListSkeleton = () => {
  return (
    <div className={s.list}>
      <MessageSkeleton />
      <MessageSkeleton isMine />
      <MessageSkeleton />
      <MessageSkeleton isMine />
      <MessageSkeleton />
    </div>
  );
};
